var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn custom",class:{'btn-size': _vm.size},attrs:{"data-icon":_vm.icon,"data-position":_vm.pos,"id":_vm.buttonID,"data-text":_vm.myText},on:{"click":function($event){$event.preventDefault();return _vm.getClickEvent($event)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d486015","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","a":"href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/CustomButton.vue
// module id = 108
// module chunks = 0